<template>
  <div class="col-xs-12 similarsBlock productBgBlock">
    <div class="similar-image-container">
      <div v-for="similarEntry in getSimilarEntriesOfThisGroupFromSimilarGroupData"
           :key="similarEntry.similarId"
           class="similar-image"
      >
        <img
          :src="`/files/product_similars/${similarEntry.similarDisplayValue}`"
          :alt="similarEntry.similarName"
          v-on:click="navigateToProduct(similarEntry.similarId)"
          class="img-fluid"
          width="100"
          height="100"
        >
        <span class="similar-image-text" v-html="getSimilarImageStatus(defaultValue, similarEntry)"></span>
      </div>

    </div>
  </div>
</template>

<script>
import similarSelectorMixin from '../mixins/similarSelectorMixin'

export default {
  name: 'SimilarImageSelector',
  mixins: [similarSelectorMixin],
  data () {
    return {
      version: '0.0.2',
      selected: null
    }
  },
  methods: {
    getSimilarOutOfStock (similar) {
      return similar.stock <= 0
    },
    getSimilarImageStatus (defaultValue, similar) {
      if (defaultValue === similar.similarName) {
        return '<i class="lni lni-checkmark similar-image-current_product"></i>'
      } else if (this.getSimilarOutOfStock(similar)) {
        return '<span class="similar-image-out_of_stock">Out of Stock</span>'
      }
    }
  }
}
</script>
